/**
 * Carte de France des représentants
 * Les données doivent être fournies au format JSON à l'URL indiquée dans le data-url du wrapper, avec la structure suivante :
 * {
 *   "personnes": [
 *     {
 *       "id": 1,
 *       "prenom": "Jean",
 *       "nom": "Dupont",
 *       "email": "jean.dupont@example.com",
 *       "telephone": "01 23 45 67 89",
 *       "departements": [
 *         {
 *           "code": "75",
 *           "couleur": "#ff0000"
 *         },
 *         {
 *           "code": "92",
 *           "couleur": "#00ff00"
 *         }
 *       ]
 *     }
 *   ]
 * }
 */
document.querySelectorAll('.carte-france-wrapper').forEach(wrapper => {
    const dataUrl = wrapper.dataset.url;
    const uid     = wrapper.dataset.uid;
    const svg     = wrapper.querySelector('#france-map');

    if (!svg || !dataUrl || !uid) return;

    const popup      = wrapper.querySelector(`#${uid}-popup`);
    const popupClose = wrapper.querySelector(`#${uid}-popup-close`);
    const select     = wrapper.querySelector(`#${uid}-select`);

    let selectedPath = null;

    function clientToRelative(clientX, clientY) {
        const r = wrapper.getBoundingClientRect();
        return { x: clientX - r.left, y: clientY - r.top };
    }

    function selectDept(path) {
        if (selectedPath) {
            selectedPath.style.opacity = '1';
            selectedPath.style.filter  = 'none';
            selectedPath = null;
        }

        if (path) {
            selectedPath = path;
            path.style.opacity = '0.75';
            path.style.filter  = 'brightness(1.1)';
        }
    }

    // ── Chargement des données ───────────────────────────────────────────────
    fetch(dataUrl)
        .then(r => r.json())
        .then(data => init(data.personnes))
        .catch(e => console.error('[Représentants] Erreur chargement données :', e));

    // ── Collecte de tous les départements du SVG (code + nom) ───────────────
    const allDepts = [];
    svg.querySelectorAll('path.dept:not(.inset-dept)').forEach(path => {
        allDepts.push({ code: path.dataset.code, name: path.dataset.name });
    });
    allDepts.sort((a, b) => a.code.localeCompare(b.code, undefined, { numeric: true }));

    allDepts.forEach(dept => {
        const opt = document.createElement('option');
        opt.value       = dept.code;
        opt.textContent = `${dept.code} – ${dept.name}`;
        select.appendChild(opt);
    });

    function init(personnes) {

        // Map département → personne + couleur
        const deptMap = {};
        personnes.forEach(p => {
            p.departements.forEach(d => { deptMap[d.code] = { personne: p, couleur: d.couleur }; });
        });

        // ── Coloration des départements ──────────────────────────────────────
        svg.querySelectorAll('path.dept').forEach(path => {
            const code     = path.dataset.code;
            const entry    = deptMap[code];
            const personne = entry?.personne;

            path.style.fill        = entry ? entry.couleur : '#e5e7eb';
            path.style.stroke      = '#fff';
            path.style.strokeWidth = '0.8';
            path.style.cursor      = 'pointer';
            path.style.transition  = 'opacity .15s, filter .15s';

            path.addEventListener('mouseenter', () => {
                path.style.opacity = '0.75';
                path.style.filter  = 'brightness(1.1)';
            });
            path.addEventListener('mouseleave', () => {
                if (path === selectedPath) return;
                path.style.opacity = '1';
                path.style.filter  = 'none';
            });
            path.addEventListener('click', e => {
                const rel = clientToRelative(e.clientX, e.clientY);
                selectDept(path);
                showPopup(code, path.dataset.name, entry?.personne, rel.x, rel.y);
            });
        });

        // ── Select département ────────────────────────────────────────────────
        select.addEventListener('change', () => {
            const code = select.value;

            if (!code) {
                closePopup();
                return;
            }

            const path = svg.querySelector(`path.dept[data-code="${code}"]:not(.inset-dept)`);
            if (!path) return;

            path.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(() => {
                const r   = path.getBoundingClientRect();
                const rel = clientToRelative(r.left + r.width / 2, r.top + r.height / 2);
                selectDept(path);
                showPopup(code, path.dataset.name, deptMap[code]?.personne, rel.x, rel.y);
            }, 350);
        });
    }

    // ── Affichage du popup ───────────────────────────────────────────────────
    function showPopup(code, name, personne, relX, relY) {
        wrapper.querySelector(`#${uid}-popup-dept-name`).textContent = name;

        const elPersonne   = wrapper.querySelector(`#${uid}-popup-personne`);
        const elNoPersonne = wrapper.querySelector(`#${uid}-popup-no-personne`);

        if (personne) {
            wrapper.querySelector(`#${uid}-popup-nom`).textContent = personne.prenom + ' ' + personne.nom.toUpperCase();

            const elEmail = wrapper.querySelector(`#${uid}-popup-email`);
            elEmail.textContent = 'Contact';
            elEmail.href = 'mailto:' + personne.email;

            const digits = personne.telephone.replace(/[.\s\-()]/g, '');
            const href   = 'tel:' + (digits.startsWith('+') ? digits : '+33' + digits.replace(/^0/, ''));
            const placeholder = wrapper.querySelector(`#${uid}-popup-tel-placeholder`);
            placeholder.innerHTML = `Tel: <a id="${uid}-popup-tel" href="${href}">${personne.telephone}</a>`;

            elPersonne.classList.remove('d-none');
            elNoPersonne.classList.add('d-none');
        }
        else {
            elPersonne.classList.add('d-none');
            elNoPersonne.classList.remove('d-none');
        }

        popup.classList.remove('d-none');
        positionPopup(relX, relY);
    }

    function positionPopup(relX, relY) {
        const margin = 12;
        const pw = popup.offsetWidth  || 230;
        const ph = popup.offsetHeight || 120;
        const cw = wrapper.offsetWidth;
        const ch = wrapper.offsetHeight;
        let   x  = relX + margin;
        let   y  = relY + margin;

        if (x + pw > cw) x = relX - pw - margin;
        if (y + ph > ch) y = relY - ph - margin;
        if (x < 0) x = margin;
        if (y < 0) y = margin;

        popup.style.left = x + 'px';
        popup.style.top  = y + 'px';
    }

    // ── Fermeture popup ──────────────────────────────────────────────────────
    function closePopup() {
        popup.classList.add('d-none');
        select.value = '';
        selectDept(null);
    }

    popupClose.addEventListener('click', closePopup);
    document.addEventListener('click', e => {
        if (!popup.contains(e.target) && !e.target.closest('path.dept') && e.target !== select) {
            closePopup();
        }
    });
});
